import { FileText, AlertTriangle, CheckCircle, ExternalLink } from 'lucide-react';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container max-w-4xl">
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12">
          <div className="flex items-center gap-3 mb-6">
            <FileText className="w-8 h-8 text-blue-600" />
            <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
          </div>
          
          <p className="text-gray-500 mb-8">Last updated: January 2025</p>

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">1. Acceptance of Terms</h2>
              <p>By accessing and using AutoSearchSA, you accept and agree to be bound by these Terms of Service. If you do not agree, please do not use our service.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">2. Service Description</h2>
              <p className="mb-3">AutoSearchSA is a car search aggregation platform that:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Aggregates vehicle listings from multiple South African dealers and platforms</li>
                <li>Provides search and comparison tools</li>
                <li>Connects users with inspection, insurance, and finance services</li>
                <li>Displays estimated costs based on publicly available rates</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                <AlertTriangle className="w-5 h-5 text-amber-500" />
                3. Disclaimer
              </h2>
              <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-4">
                <p className="font-semibold text-amber-800 mb-2">Important:</p>
                <ul className="text-amber-700 space-y-2 text-sm">
                  <li>• Vehicle listings are sourced from third-party websites and may change without notice</li>
                  <li>• Prices, availability, and specifications should be verified with the seller</li>
                  <li>• Finance and insurance estimates are indicative only and not quotes</li>
                  <li>• AutoSearchSA is not a dealer and does not sell vehicles directly</li>
                  <li>• We do not guarantee the accuracy of third-party data</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">4. Third-Party Services</h2>
              <p className="mb-3">When you click through to external websites or services:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>You are subject to their terms and privacy policies</li>
                <li>AutoSearchSA is not responsible for their content or services</li>
                <li>Any transactions are between you and the third party</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">5. User Conduct</h2>
              <p className="mb-3">You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Use automated systems to scrape or extract data</li>
                <li>Interfere with the operation of the website</li>
                <li>Submit false or misleading information</li>
                <li>Use the service for any unlawful purpose</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">6. Intellectual Property</h2>
              <p>All content on AutoSearchSA, including logos, design, and text, is owned by AutoSearchSA or its licensors. Vehicle images and descriptions are sourced from third-party dealers.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">7. Limitation of Liability</h2>
              <p>AutoSearchSA shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of the service or reliance on any information provided.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">8. Changes to Terms</h2>
              <p>We may update these terms at any time. Continued use of the service after changes constitutes acceptance of the new terms.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">9. Governing Law</h2>
              <p>These terms are governed by the laws of the Republic of South Africa.</p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 mb-3">10. Contact</h2>
              <p>For questions about these terms, contact us at: <a href="mailto:autosearchsa@gmail.com" className="text-blue-600 hover:underline">autosearchsa@gmail.com</a></p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms;
